module.exports = __webpack_public_path__ + "img/icon-themes.fd8f5999.svg";